/**
 * Operational dashboard section catalog — show/hide/reorder module panels.
 */

import { TILE_PLACEMENTS } from './executiveTileCatalog';

export const OPERATIONAL_SECTIONS = [
  { id: 'rcm_performance_kpis', title: 'RCM Performance KPIs', sortOrder: 1, enabled: true },
  { id: 'denial_management', title: 'Denial Management', sortOrder: 2, enabled: true },
  { id: 'claims_processing', title: 'Claims Processing', sortOrder: 3, enabled: true },
  { id: 'charge_management', title: 'Charge Management', sortOrder: 4, enabled: true },
  { id: 'insurance_verification', title: 'Insurance Verification', sortOrder: 5, enabled: true },
  { id: 'prior_authorization', title: 'Prior Authorization', sortOrder: 6, enabled: true },
  { id: 'ar_posting', title: 'A/R Posting', sortOrder: 7, enabled: true },
  { id: 'clearinghouse', title: 'EDI / Clearinghouse', sortOrder: 8, enabled: true },
];

export const OPERATIONAL_PLACEMENTS = {
  HIGHLIGHT: TILE_PLACEMENTS.OPERATIONAL_HIGHLIGHT,
};

/** Stable default section order for settings layout editor (must not be recreated per render). */
export const DEFAULT_OPERATIONAL_SECTION_ORDER = OPERATIONAL_SECTIONS.map((section) => section.id);

function applySortOrder(items, orderIds) {
  if (!orderIds?.length) {
    return [...items].sort((a, b) => a.sortOrder - b.sortOrder);
  }
  const byId = new Map(items.map((item) => [item.id, item]));
  const ordered = orderIds.map((id) => byId.get(id)).filter(Boolean);
  const remaining = items
    .filter((item) => !orderIds.includes(item.id))
    .sort((a, b) => a.sortOrder - b.sortOrder);
  return [...ordered, ...remaining];
}

export function getEnabledOperationalCatalog(layoutOverrides = {}) {
  const disabled = new Set(layoutOverrides.disabledOperationalSectionIds || []);
  const sections = OPERATIONAL_SECTIONS.filter((s) => s.enabled && !disabled.has(s.id));
  return {
    sections: applySortOrder(sections, layoutOverrides.operationalSectionOrder),
  };
}

export function isOperationalSectionEnabled(sectionId, layoutOverrides = {}) {
  const disabled = new Set(layoutOverrides.disabledOperationalSectionIds || []);
  return !disabled.has(sectionId);
}
